import { render, staticRenderFns } from "./MainTypeCard.vue?vue&type=template&id=951125a4&scoped=true"
import script from "./MainTypeCard.vue?vue&type=script&lang=ts"
export * from "./MainTypeCard.vue?vue&type=script&lang=ts"
import style0 from "./MainTypeCard.vue?vue&type=style&index=0&id=951125a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951125a4",
  null
  
)

export default component.exports